import { ComposedTheme, createUseStyles } from '@glu/theming';
import registerDefaults from '../themeDefaults';
import { IAccordionPanelHeaderProps } from './AccordionPanelHeader';

registerDefaults();

type TIconRight = IAccordionPanelHeaderProps['iconRight'];

const styles = ({
  accordion: {
    header: { color, cursor, fontFamily, fontSize, fontWeight, lineHeight, outlineStyle, padding },
  },
}: ComposedTheme) => ({
  accordionHeader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    fontFamily,
    fontWeight,
    fontSize,
    lineHeight,
    color,
    cursor,
    flexDirection: (iconRight: TIconRight) => (iconRight ? 'row-reverse' : undefined),
    justifyContent: (iconRight: TIconRight) => (iconRight ? 'space-between' : undefined),
    width: (iconRight: TIconRight) => (iconRight ? '100%' : undefined),
    border: 'none',
    backgroundColor: 'transparent',
    padding: '6px 0',
    '&:focus': {
      outline: 'none',
      '& $accordionHeaderContent': {
        outline: outlineStyle,
      },
    },
    '& > div:first-child': {
      position: 'relative',
      top: 3,
    },
  },
  accordionHeaderContent: {
    padding,
    textAlign: 'left',
  },
});

export default createUseStyles(styles);
